import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  // CDN を変えたい場合は data-replay-web-page-src-value で上書き
  static values = {
    src: { type: String, default: 'https://cdn.jsdelivr.net/npm/replaywebpage@2.3.15/ui.js' },
    archive: { type: String, default: '' }
  }

  connect () {
    this.loadLibAndBoot()
    this.setupPartSelector()
  }

  // ------------------------------------------------------------
  // ui.js が読み込まれ、<replay-web-page> が定義されるまで待って
  // から “DOMContentLoaded / load” を投げ直す
  // ------------------------------------------------------------
  async loadLibAndBoot () {
    if (!customElements.get('replay-web-page')) {
      await this.ensureLibLoaded()              // 初回のみロード
    }

    // Safari 16 対策（optional）: 未 upgrade タグを明示的に upgrade
    document.querySelectorAll('replay-web-page:not(:defined)')
            .forEach(el => customElements.upgrade?.(el))

    this.fireBootHooks()                        // boot() を強制実行
  }

  // ui.js を一度だけ <head> へ追加。既にロード中なら待つだけ
  ensureLibLoaded () {
    return new Promise((resolve, reject) => {
      const pending = document.querySelector('script[data-replaywebpage]')
      if (pending) {
        customElements.whenDefined('replay-web-page').then(resolve)
        return
      }

      const s = document.createElement('script')
      s.src   = this.srcValue
      s.async = true
      s.dataset.replaywebpage = 'true'
      s.onload  = () => customElements.whenDefined('replay-web-page').then(resolve)
      s.onerror = reject
      document.head.appendChild(s)
    })
  }

  // DOMContentLoaded / load を合成して ui.js 内の boot() を発火
  fireBootHooks () {
    document.dispatchEvent(
      new Event('DOMContentLoaded', { bubbles: true, cancelable: true })
    )
    window.dispatchEvent(new Event('load'))
  }

  // 分割ファイルのセレクター設定
  setupPartSelector () {
    const selector = document.querySelector('#warc-part-selector')
    if (!selector) return

    selector.addEventListener('change', (e) => {
      const partNumber = e.target.value
      const archiveId = e.target.dataset.webArchiveId
      
      // 新しいURLを生成
      const newSource = `/spk/web_archives/${archiveId}/file?part=${partNumber}`
      
      // replay-web-pageコンポーネントを再作成
      const viewer = document.querySelector('#replay-viewer')
      if (viewer) {
        const newViewer = viewer.cloneNode(false)
        newViewer.setAttribute('source', newSource)
        viewer.parentNode.replaceChild(newViewer, viewer)
        
        // 再度boot処理を実行
        this.fireBootHooks()
      }
    })
  }

  // Turbo キャッシュへ入る前にプレイヤーを破棄したい場合はコメント解除
  // disconnect () {
  //   this.element.querySelectorAll('replay-web-page').forEach(el => el.remove())
  // }
}
